const CoverMainColor = {
  WHITE: '#ECECE7',
  PINK: '#F2EBE8',
  GOLD: '#9F7D4C',
  RED: '#D4584C',
  DARK_BLUE: '#19252B',
  GREEN: '#19482D',
  LIGHT_BLUE: '#1A3948',
};

module.exports = CoverMainColor;
